<rav-modal modalId="backup-codes" modalTitle="Get Backup Codes">
  <div class="primary-color">
    <p>
      If you lose your phone or otherwise can't get codes via text, voice call,
      or Google Authenticator, you can use backup codes to sign in.
    </p>
    <ul class="padding-left-1">
      <li>
        After you use a backup code to sign in, it becomes inactive. As each code can be used only
        once, you might want to mark the code as used.
      </li>
      <li>
        You can generate a new set of 12 codes whenever you want. After creating a new set, the old
        set automatically becomes inactive.
      </li>
    </ul>
    <p>
      After downloading your backup codes store them somewhere safe. If you think backup codes were stolen or
      if you run out, select Get New Backup Codes. Your old set of backup codes will automatically become inactive.
    </p>
  </div>
  <div *ngIf="backupCodes">
    <ul class="grid-x grid-padding-x small-up-1 large-up-2">
      <li *ngFor="let code of backupCodes" class="cell">
        {{code}}
      </li>
    </ul>
    <button type="button" class="button" (click)="copyCodes()">Copy Codes</button>

  </div>
  <button type="button" (click)="generateCodes()" class="button expanded margin-right-1">Get New Backup Codes</button>
</rav-modal>
